'use client'

import Link from "next/link"

const groups = [
    {
        title: "Studio",
        links: [
            { label: "Raya", href: "/raya" },
            { label: "Convocation", href: "/convocation" },
            { label: "The Gallery", href: "#gallery" },
            { label: "Services", href: "#featured-sessions" },
        ]
    }
]

export const FooterLinks = () => {
    return (
        <div className="grid grid-cols-1 gap-12 lg:gap-24">
            {groups.map((group, idx) => (
                <div key={idx} className="space-y-6">
                    <h4 className="text-[10px] uppercase tracking-[0.3em] font-medium text-foreground">
                        {group.title}
                    </h4>
                    <ul className="space-y-4">
                        {group.links.map((link, lIdx) => (
                            <li key={lIdx}>
                                <Link
                                    href={link.href}
                                    className="text-[13px] text-muted-foreground hover:text-primary transition-colors font-light tracking-wide"
                                >
                                    {link.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            ))}
        </div>
    )
}
